<template>
  <button
    :content="tooltip"
    v-tippy="{ arrow: true, theme: 'ontick' }"
    :class="btnClass"
    :style="refreshStyle"
    @click="clickEvent"
  >
    <i v-html="$icons.refresh" :class="[{ 'animate-spin': animatation }, iconClass]"></i>
    <span class="sr-only"> {{ tooltip }} </span>
  </button>
</template>

<script>
import event_bus from "../../../shared/utils/event_bus";

export default {
  props: {
    tooltip: {
      type: String,
      default: "Atualizar",
    },
    name: {
      type: String,
      default: "refresh",
    },
    iconClass: {
      type: String,
      default: "text-ontick-blue-600",
    },
    newStyle: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      animatation: false,
      refreshStyle: this.newStyle
        ? {
            "box-shadow": "0px 2px 4px 0px rgba(0, 0, 0, 0.8)",
          }
        : {},
      btnClass: {
        "h-full w-10 rounded-md bg-ontick-graphite-500 shadow flex items-center justify-center filter hover:brightness-125 transition-all":
          this.newStyle,
        "h-full w-10 rounded-md bg-ontick-steel-500 shadow flex items-center justify-center filter hover:brightness-125 transition-all":
          !this.newStyle,
      },
    };
  },

  methods: {
    clickEvent() {
      this.$emit("click");
      this.animate();
    },
    animate() {
      this.animatation = true;
      setTimeout(() => {
        this.animatation = false;
      }, 1000);
    },
  },

  mounted() {
    event_bus.$on("REFRESH_ANIM", (name) => {
      if (name === this.name) {
        this.animate();
      }
    });
  },
};
</script>

<style></style>
